import { z } from "zod";

/**
 * Reusable sub-schema: { name, description } item.
 * Used by classification categories and summarisation focusElements.
 */
export const NameDescriptionItemSchema = z.object({
  name: z.string(),
  description: z.string()
});

export type NameDescriptionItem = z.infer<typeof NameDescriptionItemSchema>;
